<div class="summary-bar-wrapper">
  <div class="summary-bar-main">
    <div class="summary-bar-label">{{ label }}</div>
    <div class="summary-bar-message" [style.color]="messageColor">{{ message }}</div>
  </div>
  <div class="summary-bar-color" *ngIf="showRagBreakdown">
    <app-rag-breakdown-bar
      style="width: 100%"
      [canClickRag]="false"
      [ragBreakdowns]="ragBreakdowns"
      [tooltipTitle]="T.common.item_status_breakdown | translate: { item: label }"
      ></app-rag-breakdown-bar>
  </div>
</div>
